import {useState} from "react";

import {HomePayFeeFormOnRampValues} from "../../utils";

import HomePayFeeFormOnRampStep0 from "./HomePayFeeFormOnRampStep0";
import HomePayFeeFormOnRampStep1 from "./HomePayFeeFormOnRampStep1";
import {useCredit} from "../../providers/CreditStatusProvider";

interface HomePayFeeFormOnRampProps {
  onCloseModal: () => void;
  handleBack: () => void;
}

function HomePayFeeFormOnRamp(
  {
    onCloseModal,
    handleBack,
  }:HomePayFeeFormOnRampProps) {
  const { creditFeesOwed } = useCredit();

  const [formData, setFormData] = useState<HomePayFeeFormOnRampValues>({
    amount: creditFeesOwed,
    fiatCurrency: "usd",
    tokens: ["USDC", "BASE"],
    accountNumber: "",
    routingNumber: "",
    companyAddress: "",
    country: "",
    province: "",
    city: "",
    postalCode: "",
  })

  const [currentStep, setCurrentStep] = useState(0)

  const handleNextStep = (newFormData: HomePayFeeFormOnRampValues) => {
    setFormData(prev => ({...prev, ...newFormData}))

    if (currentStep === steps.length - 1) {
      alert(JSON.stringify(newFormData, null, 2))
    } else {
      setCurrentStep(prev => prev + 1)
    }
  }

  const handlePrevStep = (newFormData: HomePayFeeFormOnRampValues) => {
    setFormData(prev => ({...prev, ...newFormData}))
    setCurrentStep(prev => prev - 1)
  }

  const steps = [
    <HomePayFeeFormOnRampStep0
      data={formData}
      next={handleNextStep}
      handleBack={handleBack}
      onCloseModal={onCloseModal}
    />,

    <HomePayFeeFormOnRampStep1
      data={formData}
      prev={handlePrevStep}
      onCloseModal={onCloseModal}
    />,
  ]

  return (
    <>
      {steps[currentStep]}
    </>
  );
}

export default HomePayFeeFormOnRamp;